<template>
  <transition name="fade">
    <div v-if="isChatWindowOpen" class="chat-window">
      <div class="chat-header">
        <h3>{{ $t('chatTitle') }}</h3>
        <button size="mini" @click="closeChatWindow">x</button>
      </div>
      <div class="chat-body">
        <div class="chat-message">
          <p>{{ $t('defaultMessage') }}</p>
        </div>
        <div class="input-container">
          <input type="text" v-model="phoneNumber" :placeholder="$t('phonePlaceholder')"/>
          <button @click="submitPhoneNumber">{{ $t('sendPhone') }}</button>
        </div>
        <div class="input-container">
          <textarea v-model="question" :placeholder="$t('questionPlaceholder')"></textarea>
          <button @click="submitQuestion">{{ $t('sendQuestion') }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { inject } from 'vue';
import axios from "axios";
import {ElMessage} from "element-plus";

const isChatWindowOpen = inject('isChatWindowOpen');

const phoneNumber = ref('');
const question = ref('');

function closeChatWindow() {
  if (isChatWindowOpen) {
    isChatWindowOpen.value = false;
  }
}

async function submitPhoneNumber() {
  try {
    const response = await axios.post('http://47.113.126.50:8301/custom/add', { phone: phoneNumber.value });
    ElMessage({
      message: '电话号码提交成功',
      type: 'success'
    });
    console.log('Phone number submitted:', response.data);
    phoneNumber.value = ''; // 清空输入框
  } catch (error) {
    ElMessage.error('提交电话号码失败');
    console.error('Failed to submit phone number:', error);
  }
}

async function submitQuestion() {
  try {
    const response = await axios.post('http://47.113.126.50:8301/custom/add', { question: question.value });
    ElMessage({
      message: '问题提交成功',
      type: 'success'
    });
    console.log('Question submitted:', response.data);
    question.value = ''; // 清空输入框
  } catch (error) {
    ElMessage.error('提交问题失败');
    console.error('Failed to submit question:', error);
  }
}


onMounted(() => {
  if (isChatWindowOpen) {
    isChatWindowOpen.value = false; // 初始化时关闭弹窗
  }
});
</script>

<style scoped>
.chat-window {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 300px;
  max-height: 80vh;
  overflow-y: auto;
  z-index: 1000;
  transition: opacity 0.3s ease;
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #e6e6e6;
  border-radius: 8px 8px 0 0;
}

.chat-header h3 {
  margin: 0;
  font-size: 14px;
}

.chat-header button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.chat-body {
  padding: 10px;
}

.chat-message {
  margin-bottom: 10px;
  background-color: #e6e6e6;
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
}

.input-container {
  display: flex;
  margin-bottom: 10px;
}

.input-container input,
.input-container textarea {
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
}

.input-container button {
  padding: 8px 16px;
  background-color: #185BF8;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>